import React from 'react';
import InstalledBaseTree from "../../components/InstalledBaseTree";

const InstalledBaseScreen = () => {
    return (
        <div style={{padding: "12px 0", overflowX: "scroll", flex: 1, minWidth: 0}}>
            <InstalledBaseTree/>
        </div>
    );
}

export default InstalledBaseScreen;
